<template>
  <gj-modal
      size="full-middle"
      v-bind="$attrs"
      v-on="$listeners"
      not-footer-padding
      :visible.sync="modalVisible"
      :contentStyle="{'height': '100%','display': 'flex', 'flex-direction': 'column'}"
  >
    <template #header>
      添加商品
    </template>
    <template #content>
      <el-row>
        <el-col :span="16">
          <gj-search-input
              width="500px"
              placeholder="搜索ASIN,MSKU,SKU,商品标题,产品名称"
              style="margin-bottom: 12px"
              v-model="fuzzyParam"
              @input="searchKeyword"
          >
          </gj-search-input>
        </el-col>
        <el-col :span="8" style="text-align: right; padding-right: 20px">
          <el-checkbox @change="$gjNoticeQuery" v-model="available">仅查看库存不为0</el-checkbox>
        </el-col>
      </el-row>
      <div style="flex: 1; overflow: auto;">
      <gj-table
          ref="gjTable"
          adaptParent
          :columns="columns"
          :data="data"
          :offset-height="54"
          :show-pagination="false"
          selection
          :pagination="pagination"
          :loading="loading"
          :index="false"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :selectable="notEqSelectable('availableQuantity', null)"
      >
        <template v-slot:listingInfo="{ row }">
          <div>
            <gj-tooltip :text-line="1" :content="row.title">{{row.title}}</gj-tooltip>
          </div>
          <div>{{row.asin}}
            <span v-if="row.asin" v-copy="row.asin"
              class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
        </template>
        <template v-slot:msku="{ row }">
          <div>
            {{row.msku}}
            <span v-if="row.msku" v-copy="row.msku"
                  class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
          <div>
            {{row.fnsku}}
            <span v-if="row.fnsku" v-copy="row.fnsku"
                  class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
        </template>
        <template v-slot:productInfo="{ row }">
          <div><gj-tooltip :text-line="1" :content="row.productName">{{row.productName}}</gj-tooltip></div>
          <div>{{row.sku}}
            <span v-if="row.sku" v-copy="row.sku"
                  class="copy-icon gj-cell-display-switch">
              <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
        </template>
      </gj-table>
      </div>
    </template>
    <template #footer>
      <gj-button @click.stop="cancel">取消</gj-button>
      <gj-button type="primary" @click.stop="confirm">确定</gj-button>
    </template>
  </gj-modal>
</template>

<script>
    import {modalMixIn, queryMixin} from "../../../../../minxins";
    import {createFulfillmentAddGoods} from "../../../../../api/sale";

    export default {
        name: "add-goods",
        mixins:[modalMixIn, queryMixin],
        props: {
            marketId: {
                type: Number,
                require: true,
            }
        },
        data() {
            return {
                available: true,
                fuzzyParam: '',
                columns:[
                    {id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '60px', default: true},
                    {id: 'listingInfo', header: '商品标题/ASIN', field: 'slot:listingInfo', minWidth: '280px', default: true},
                    {id: 'MSKU', header: 'MSKU/FNSKU', field: 'slot:msku', minWidth: '150px', default: true},
                    {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '160px', default: true},
                    {id: 'availableQuantity', header: '产品库存', field: 'availableQuantity', minWidth: '120px', default: true},
                ],
                data: [
                    // {
                    //     marketId: '1111',
                    //     msku: '222',
                    //     shipmentQuantity: 12,
                    // }
                ],
                searchKeyword: this._.debounce(this.$gjNoticeQuery, 500),
                selectedRows: null,
            }
        },
        methods: {
            $gjQuery() {
                this.loading = true;
                createFulfillmentAddGoods({
                    model: {
                        marketId: this.marketId,
                        available: this.available,
                        fuzzyParam: this.fuzzyParam,
                    },
                    ...this.queryPagination,
                    ...this.querySort,
                }).then((data) => {
                    this.data = data.records;
                    this.pagination = this.getPagination(data);
                }).complete(() => this.loading = false)
            },
            notEqSelectable(prop, value) {
                return (row) => row[prop] !== value;
            },
            confirm() {
                const tableRef = this.$refs['gjTable'].$refs['gjTable'];
                this.$emit('after', tableRef.selection);
            }
        }
    }
</script>

<style scoped>
  /deep/ .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 12px;
    color: #666;
    
  }
</style>
